import styled from 'styled-components';

import { media } from '@theme/media';
import { CONTAINER_PADDING } from '@components/blocks/blocks.constants';

import { containerStyles } from '../blocks.styles';

export const Container = styled.div<{ backgroundColor: string; textColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
`;
export const InnerContainer = styled.div`
  ${containerStyles};
  min-height: var(--vh);
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
  pointer-events: none;
`;

export const Masthead = styled.h3`
  font-size: 14px;
  line-height: 1.4em;
  letter-spacing: 0.02em;
  font-weight: 500;
  text-transform: uppercase;
  padding-bottom: 51px;
  margin: 0;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const Headline = styled.h1<{ isLongWord: boolean }>`
  font-size: ${({ isLongWord }) => (isLongWord ? '32px' : '58px')};
  line-height: 0.9em;
  font-weight: 500;
  text-align: center;
  margin: 0;

  ${media.mobile} {
    font-size: 58px;
  }

  ${media.desktop} {
    font-size: 76px;
    line-height: 0.9em;
    max-width: 676px;
  }
`;

export const Subhead = styled.p`
  font-size: 20px;
  line-height: 1.25;
  letter-spacing: 0;
  font-weight: 500;
  text-align: center;
  margin: 51px 0 ${CONTAINER_PADDING}px;
`;
